<template>
  <div class="community-guidelines-page">
    <PageTitle
      title="Community Guidelines"
      subtitle="Our community guidelines can be found below."
      backgroundClass="-banner is-dark -banner-10"
    />
    <section class="section">
      <div class="container">
        <div class="box">
          <CommunityGuidelinesCopy />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import CommunityGuidelinesCopy from "@/components/copy/CommunityGuidelinesCopy.vue";

export default {
  name: "communityGuidelinesPage",
  components: {
    PageTitle,
    CommunityGuidelinesCopy
  }
};
</script>

<style scoped lang="scss"></style>
